import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  alpha,
} from '@mui/material';
import { Warning as WarningIcon, Close as CloseIcon } from '@mui/icons-material';

const ConfirmacaoNaoCompareceuDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  senha, 
  customTheme, 
  TransitionComponent, 
  Backdrop 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
      TransitionProps={{
        timeout: {
          enter: 400,
          exit: 300
        }
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: alpha(customTheme.palette.common.black, 0.5),
          backdropFilter: 'blur(2px)',
          transition: 'backdrop-filter 300ms cubic-bezier(0.4, 0, 0.2, 1)'
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: `0 8px 32px ${alpha(customTheme.palette.common.black, 0.2)}`,
          maxWidth: 450,
          mx: 2,
          mb: { xs: 1, sm: 4 },
          overflowY: 'auto',
          transition: 'transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1) !important',
          '&.MuiDialog-paper': {
            transform: open ? 'translateY(0) !important' : 'translateY(100%) !important'
          }
        }
      }}
    >
      <DialogTitle sx={{ 
        pb: 1, 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${alpha(customTheme.palette.primary.main, 0.1)}`
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon sx={{ color: customTheme.palette.warning.main, mr: 1.5 }} />
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            Confirmar Não Comparecimento
          </Typography>
        </Box>
        <IconButton 
          edge="end" 
          color="inherit" 
          onClick={onClose} 
          aria-label="fechar"
          sx={{ 
            color: customTheme.palette.grey[500],
            '&:hover': {
              color: customTheme.palette.grey[800],
              bgcolor: alpha(customTheme.palette.grey[500], 0.1)
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <DialogContentText sx={{ mb: 2, color: 'text.primary' }}>
          Você está prestes a marcar a senha <strong>{senha?.numero}</strong> como <em>Não Compareceu</em>.
        </DialogContentText>
        <DialogContentText sx={{ color: 'warning.main', mb: 2 }}>
          <strong>Atenção:</strong> Esta ação é irreversível e a senha será removida da fila.
        </DialogContentText>
        <DialogContentText sx={{ color: 'text.secondary' }}>
          Certifique-se de que o cliente realmente não compareceu ao chamado antes de confirmar esta ação.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ 
            borderRadius: 2,
            px: 3,
            py: 1,
            borderWidth: '2px',
            '&:hover': {
              borderWidth: '2px'
            }
          }}
        >
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm}
          variant="contained"
          color="warning"
          sx={{ 
            borderRadius: 2,
            px: 3,
            py: 1,
            boxShadow: `0 4px 12px ${alpha(customTheme.palette.warning.main, 0.3)}`,
            '&:hover': {
              boxShadow: `0 6px 16px ${alpha(customTheme.palette.warning.main, 0.4)}`,
            }
          }}
          autoFocus
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmacaoNaoCompareceuDialog; 